import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { NotFoundError } from 'commons/errors'
import { getAnnualReviewEditMode } from '~bank-annual-review/service'

export const annualReviewEditRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `/edit/$companyId/$id`,
    beforeLoad: ({ params }) => {
      if ('id' in params && params.id && Number(params.id)) return { id: Number(params.id) }
      else throw new NotFoundError()
    },
    loader: ({ context: { id } }) => getAnnualReviewEditMode(Number(id)),
    component: lazyRouteComponent(() => import('./AnnualReviewEdit'))
  })
